/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Select } from '@oy/uidesktop';
import { useCallback, useEffect, useState } from 'react';
import { SingleValue } from 'react-select';
import styles from './BrandSwitcherDev.module.css';

type Manifest = { brands: string[]; defaultBrand: string };

export const BrandSwitcherDev = () => {
  const getAttr = useCallback(
    (k: string) => document.documentElement.getAttribute(k),
    [],
  );

  const [open, setOpen] = useState(false);
  const [brands, setBrands] = useState<string[] | null>(null);
  const [brand, setBrand] = useState<string>('');
  const [failed, setFailed] = useState(false);

  const apply = useCallback((nextBrand: string) => {
    document.documentElement.setAttribute('data-brand', nextBrand);

    localStorage.setItem('brand', nextBrand);

    if (window.__setBrand) {
      window.__setBrand(nextBrand);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const mod = await import(
          /* @vite-ignore */ 'src/styles/brand.manifest.json'
        ).catch(() => null);
        const data: Manifest = (mod as any)?.default ?? (mod as any);
        if (!data || !Array.isArray(data.brands) || data.brands.length === 0)
          throw new Error();

        if (cancelled) return;
        setBrands(data.brands);

        const fromLS =
          (typeof window !== 'undefined' && localStorage.getItem('brand')) ||
          undefined;
        const fromDOM = getAttr('data-brand') || undefined;
        const initial =
          fromLS || fromDOM || data.defaultBrand || data.brands[0];

        setBrand(initial);
        document.documentElement.setAttribute('data-brand', initial);
      } catch {
        try {
          const res = await fetch('/styles/brand.manifest.json', {
            cache: 'no-store',
          });
          if (!res.ok) throw new Error();
          const data = (await res.json()) as Manifest;
          if (!data || !Array.isArray(data.brands) || data.brands.length === 0)
            throw new Error();

          if (cancelled) return;
          setBrands(data.brands);

          const fromLS =
            (typeof window !== 'undefined' && localStorage.getItem('brand')) ||
            undefined;
          const fromDOM = getAttr('data-brand') || undefined;
          const initial =
            fromLS || fromDOM || data.defaultBrand || data.brands[0];

          setBrand(initial);
          document.documentElement.setAttribute('data-brand', initial);
        } catch {
          if (!cancelled) setFailed(true);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [getAttr]);

  if (failed || !brands || brands.length === 0) return null;

  const onBrandChange = (
    newValue: SingleValue<{ label: string; value: string }>,
  ) => {
    if (!newValue) return;
    const b = newValue.value;
    setBrand(b);
    apply(b);
    setOpen(false);
  };

  const brandOptions = brands.map(b => ({ label: b, value: b }));

  return (
    <div className={styles.container}>
      <Button onClick={() => setOpen(true)}>🧪 {brand || 'brand'}</Button>
      {open && (
        <div className={styles.card}>
          <div className={styles.header}>
            <Select
              id="brandSelect"
              value={brandOptions.find(e => e.value === brand) || null}
              onChange={onBrandChange}
              className={styles.select}
              options={brandOptions}
            />
          </div>
        </div>
      )}
    </div>
  );
};
